import React, { useCallback } from 'react';
import { useField } from 'react-final-form';
import { observer } from 'mobx-react';
import { CheckboxField } from 'ksnm-common-ui/lib/Form/CheckboxField';
import { TextField } from 'ksnm-common-ui/lib/Form/InputFields';
import { RadioField } from 'ksnm-common-ui/lib/Form/RadioField';
import { SelectField } from 'ksnm-common-ui/lib/Form/SelectField';
import { TextAreaField } from 'ksnm-common-ui/lib/Form/TextAreaField';

import { controlVersionEditStore } from '@stores/dictionaryStores/controlVersionsStore/controlVersionEditStore';
import { stepTypesStore } from '@stores/dictionaryStores/stepTypesStore';

import { DescriptionStatus } from './DescriptionStatus';
import { Rounding } from './Rounding';

export const Form = observer(() => {
  const { isEditMode } = controlVersionEditStore;
  const { stepTypes } = stepTypesStore;

  const {
    input: { value: cond },
  } = useField('cond');

  const {
    input: { value: isFnsControl },
  } = useField('isFnsControl');

  const {
    input: { onChange: changeCodeFns },
  } = useField('codeFns');

  const {
    input: { onChange: changePremise },
  } = useField('premise');

  const {
    input: { value: ctrlType, onChange: changeCtrlType },
  } = useField('ctrlType');

  const {
    input: { onChange: changeDelta },
  } = useField('delta');

  const {
    input: { onChange: changeRoundingType },
  } = useField('roundingType');

  const {
    input: { onChange: changeDecimalQty },
  } = useField('decimalQty');

  const onChange = useCallback(
    (value) => {
      if (!value) changePremise(undefined);
    },
    [changePremise],
  );

  const onChangeIsFnsControl = useCallback(
    (value) => {
      if (!value) changeCodeFns(undefined);
    },
    [changeCodeFns],
  );

  const onChangeCodeFns = useCallback(
    (value) => {
      if (value) changeDelta(undefined);
    },
    [changeDelta],
  );

  const onChangeCtrlType = useCallback(
    (ev) => {
      changeCtrlType(ev.target.value);

      if (ev.target.value === 'L') {
        changeDelta(undefined);
        changeRoundingType(undefined);
        changeDecimalQty(undefined);
      }
    },
    [changeCtrlType, changeDecimalQty, changeDelta, changeRoundingType],
  );

  return (
    <>
      <TextField
        name="stepNum"
        label="Технический номер шага"
        disabled
        size="small"
        groupStyle={!isEditMode}
        required
      />

      <TextField
        name="stepCodeExt"
        label="Внешний код шага"
        disabled={!isEditMode}
        size="small"
        groupStyle={!isEditMode}
        required
        maxLength={100}
      />

      <CheckboxField
        name="isFnsControl"
        label="Является контролем в сервисах ФНС"
        groupStyle={!isEditMode}
        disabled={!isEditMode}
        onChange={onChangeIsFnsControl}
      />

      {isFnsControl && (
        <TextField
          name="codeFns"
          label="Код контроля (ФНС)"
          disabled={!isEditMode}
          size="small"
          groupStyle={!isEditMode}
          maxLength={100}
          onChange={onChangeCodeFns}
        />
      )}

      <SelectField
        items={stepTypes}
        name="stepType"
        label="Тип шага"
        disabled={!isEditMode}
        size="small"
        groupStyle={!isEditMode}
        required
      />

      <TextAreaField
        name="stepName"
        label="Наименование шага"
        disabled={!isEditMode}
        size="small"
        groupStyle={!isEditMode}
        required
        maxLength={250}
        autoSize
      />

      <TextAreaField
        name="stepDesc"
        label="Описание шага"
        disabled={!isEditMode}
        size="small"
        groupStyle={!isEditMode}
        required
        maxLength={1000}
        autoSize
      />

      <CheckboxField
        name="cond"
        label="Необходима предпосылка"
        groupStyle={!isEditMode}
        disabled={!isEditMode}
        onChange={onChange}
      />

      {cond && (
        <TextAreaField
          name="premise"
          label="Проверка применимости"
          disabled={!isEditMode}
          size="small"
          groupStyle={!isEditMode}
          maxLength={255}
          autoSize
        />
      )}

      <TextAreaField
        name="formula"
        label="Логика контроля"
        disabled={!isEditMode}
        size="small"
        groupStyle={!isEditMode}
        maxLength={255}
        autoSize
        required
      />

      <RadioField
        name="ctrlType"
        label="Тип контроля"
        disabled={!isEditMode}
        options={[
          { label: 'L - логическое', value: 'L' },
          { label: 'S - числовое', value: 'S' },
        ]}
        onChange={onChangeCtrlType}
      />

      {ctrlType === 'S' && <Rounding />}

      <DescriptionStatus />
    </>
  );
});
